import { css } from "@emotion/react";
import { FC } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";

import {
  Button,
  DesignToken,
  Heading,
  ProgressCircle,
  RadiusToken,
  SpacingToken,
  Text,
} from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { config } from "config/config";
import { trialPeriod } from "constants/trial";
import { EventPlace, trackEngagement } from "helpers/analytics";
import { isInIframe } from "helpers/app";
import { SubscriptionRoutes } from "routes/subscription";
import { getCurrentSubscriptionDaysLeft } from "store/entities/subscriptions";
import { withVar } from "themes/helpers";
import { plural } from "utils/string";

interface IProps {
  onClose: () => void;
}

export const TrialDaysAlert: FC<IProps> = ({ onClose }) => {
  const history = useHistory();
  const trialDaysLeft = useSelector(getCurrentSubscriptionDaysLeft);
  const displayAsWarning = trialDaysLeft <= 7;
  const trialProgress = Math.round((trialDaysLeft / trialPeriod) * 100);

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleSubscribe = () => {
    const isSecondHalf = trialDaysLeft <= trialPeriod / 2;

    trackEngagement("Checklist: Subscribe", EventPlace.Onboarding, {
      eventPlace: "expanded",
      state: isSecondHalf ? "secondHalf" : "firstHalf",
    });
    if (isInIframe()) {
      window.open(`${config.appUrl}${SubscriptionRoutes.Plans}`);
    } else {
      history.push(SubscriptionRoutes.Plans);
      onClose();
    }
  };

  return (
    <Flex
      justifyContent="space-between"
      alignItems="center"
      padding={`${withVar(SpacingToken.Spacing3)} ${withVar(SpacingToken.Spacing4)}`}
      gap={withVar(SpacingToken.Spacing2)}
      borderRadius={withVar(RadiusToken.Radius3)}
      bg={withVar(displayAsWarning ? DesignToken.SurfaceAccentEmphasisMinWarning : DesignToken.SurfaceSecondaryDefault)}
      height="48px"
    >
      <Flex css={{ position: "relative" }} justifyContent="center">
        <ProgressCircle progressValue={trialProgress} />
        <Flex
          justifyContent="center"
          alignItems="center"
          width="30px"
          height="30px"
          borderRadius="50%"
          bg={withVar(DesignToken.SurfaceSecondaryDefault)}
          css={{ position: "absolute", top: 3, left: 3 }}
        >
          <Heading size="sm" customColor={withVar(DesignToken.ContentBasicPrimary)}>
            {trialDaysLeft}
          </Heading>
        </Flex>
      </Flex>
      <Text
        bold
        css={css`
          margin-right: auto;
        `}
      >
        {plural(trialDaysLeft, "Day", "Days")} left in your trial
      </Text>
      <Button kind="primary" onClick={handleSubscribe}>
        Subscribe
      </Button>
    </Flex>
  );
};
